import { restUrl } from 'redux/urlConfig'
import { USER_TYPE } from "./consts"

export async function putLogin(body) {
    try {
        const response = await fetch(`${restUrl}/api/login`, {
            method: 'PUT',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...body,
                type: USER_TYPE.EMPLOYEE
            })
        });

        const data = await response.json();

        return {
            response: data,
            status: response.status
        }

    } catch (error) {
        console.log('Error fetch', error)
    }
}

export async function postRegisterSeller(body) {
    try {
        const result = await fetch(`${restUrl}/api/create`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...body,
                type: USER_TYPE.EMPLOYEE
            })
        });

        const data = await result.json();

        return {
            data: data,
            status: result.status
        }

    } catch (error) {
        console.log('Error fetch', error)
    }
}
